import { ConversaCard } from './ConversaCard';
import type { Conversa } from '@/types';

interface ConversaListProps {
  conversas: Conversa[];
  selectedChannelId: string | null;
  onSelect: (channelId: string) => void;
  onToggleIA: (channelId: string, currentState: boolean) => void;
}

export function ConversaList({ conversas, selectedChannelId, onSelect, onToggleIA }: ConversaListProps) {
  if (conversas.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-ds-text-secondary text-sm">Nenhuma conversa encontrada</p>
        <p className="text-ds-text-secondary text-xs mt-1">As conversas aparecerão quando houver interação via WhatsApp</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {conversas.map((conversa) => (
        <ConversaCard
          key={conversa.channel_id}
          conversa={conversa}
          isSelected={selectedChannelId === conversa.channel_id}
          onSelect={() => onSelect(conversa.channel_id)}
          onToggleIA={() => onToggleIA(conversa.channel_id, conversa.is_ai_disabled)}
        />
      ))}
    </div>
  );
}
